/** "1 attachment" or "3 attachments". Empty for none, so a caller can test the result. */
export function attachmentCountLabel(count: number): string {
  if (!Number.isFinite(count) || count < 1) {
    return ''
  }
  const whole = Math.floor(count)
  return whole === 1 ? '1 attachment' : `${whole} attachments`
}
